import "./index.scss";

// --- Utilitaires et Librairies de base ---
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// --- Modules principaux de l'Application ---
import PageTransition from "./App/PageTransition.js";

// --- Expérience 3D et Utilitaires ---
import sources from "./Experience/sources.js";
import Resources from "./Experience/Utils/Resources.js";

import Time from "./Experience/Utils/Time.js";
import Sizes from "./Experience/Utils/Sizes.js";
import Scroll from "./Experience/World/Scroll.js";
import Navigation from "./App/Navigation.js";

import Preloader from "./Experience/Preloader.js";
import Experience from "./Experience/Experience.js";

import Animations from "./App/Animations.js";

import Home from "./App/Home.js";
import Project from "./App/Project.js";

// import TransitionController from "./Experience/TransitionController.js";
// import ImageDistortion from "./Experience/ImageDistortion.js";

class App {
  constructor() {
    this.resources = new Resources(sources);

    this.time = new Time();
    const mainCanvas = document.querySelector("canvas.experience");
    this.sizes = new Sizes(mainCanvas);

    this.scroll = new Scroll();
    this.scrollPositions = {};

    this.experience = new Experience(this);
    this.preloader = new Preloader(this.experience);

    this.currentPageLogic = null;
    this.currentAnimations = null;

    PageTransition.init(this);

    this.initEventListeners();
    this.init();
  }

  init() {
    gsap.ticker.add((time) => {
      this.scroll.update(time * 1000);
    });
    this.time.on("tick", () => {
      this.update();
    });

    this.scroll.lenis.on("scroll", ScrollTrigger.update);
  }

  initNavigation(namespace) {
    if (namespace === "home") {
      this.navigation = new Navigation(this);
    }
  }

  initPageInteractions(next) {
    if (this.currentPageLogic) this.currentPageLogic.destroy();

    if (next.namespace === "home") {
      this.currentPageLogic = new Home(next.container);
    } else if (next.namespace === "project") {
      this.currentPageLogic = new Project(next.container);
    }
  }

  prepareInitialAnimations(container) {
    // Prépare les animations
    this.currentAnimations = new Animations(container);
    PageTransition.currentAnimations = this.currentAnimations;
  }

  initEventListeners() {
    this.resources.on("progress", (progress) => {
      this.preloader.onloadAnimation(progress);
    });
    this.resources.on("ready", () => {
      this.experience.initWorld();
    });

    // Quand le preloader a fini, on lance la transition
    this.preloader.on("completed", async () => {
      await this.experience.transition.playOut();

      if(this.navigation){
        this.navigation.createTimeline()
      }

      if (this.currentAnimations) {
        this.currentAnimations.start();
        ScrollTrigger.refresh();
      }
    });
  }

  update() {
    if (this.experience) this.experience.update();
    // if (this.imageDistortion) this.imageDistortion.update();
  }

  // initImageDistortion(currentDOM) {
  //   if (this.imageDistortion) this.imageDistortion.destroy();
  //   this.imageDistortion = new ImageDistortion(
  //     document.querySelector("canvas.dom2Gl"),
  //     currentDOM,
  //     this
  //   );
  // }
}

// Lancement de l'application une fois le DOM entièrement chargé
window.addEventListener("DOMContentLoaded", () => {
  new App();
});
